import React from 'react';
import { Field } from "redux-form";
import { Translate } from "react-localize-redux";
import PrivacyDropdown from '../PrivacyDropdown/PrivacyDropdown';
import CatgoryDropdown from '../CategoryDropdown/CatgoryDropdown';
import InputField from '../InputField';
import PropTypes from "prop-types";
import './styles.scss';

const AddressForm = ({ address, member }) => (
  <React.Fragment>

    <div className="row address-row address-category-row">
      <div className="col address-category-container">
        <CatgoryDropdown selectName={`${member}.category`} />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="StreetNumber" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.street_number`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.street_number_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="Street" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.street`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.street_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="UnitNumber" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.unit_number`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.unit_number_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="Neighbourhood" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.neighbourhood`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.neighbourhood_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="CityorDistrict" /></span>
        <br></br>
        <span>*<Translate id="RequiredText" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.city_district`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.city_district_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="StateorProvince" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.state_prov`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.state_prov_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="Country" /></span>
        <br></br>
        <span>*<Translate id="RequiredText" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.country`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.country_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="PostalCodeorZIP" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.postal_zip`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.postal_zip_privacy`}
        />
      </div>
    </div>

    <div className="row address-row">
      <div className="col-2 text-center address-label">
        <span><Translate id="Other" /></span>
      </div>
      <div className="col-6">
        <Field
          name={`${member}.other`}
          type="text"
          hideLabel={true}
          component={InputField}
        />
      </div>
      <div className="col-2 address-spacer"></div>
      <div className="col-1">
        <PrivacyDropdown
          selectLabel="Privacy"
          selectName={`${member}.other_privacy`}
        />
      </div>
    </div>

  </React.Fragment>
);

AddressForm.PropTypes = {
  address: PropTypes.object,
  member: PropTypes.string,
};

export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/forms/AddressForm/AddressForm.jsx